export default "__VITE_ASSET__DA1SP$XN__";